import React from 'react'

function AdminMenu() {
    return (
        <div>
        <div id="layoutSidenav_nav">
           <nav class="sb-sidenav accordion sb-sidenav-dark" id="sidenavAccordion">
               <div class="sb-sidenav-menu">
                   <div class="nav">
                       <div class="sb-sidenav-menu-heading">Profile</div>
                       <a class="nav-link" href="">
                           <div class="sb-nav-link-icon"><i class="fa fa-user"></i></div>
                           {localStorage.getItem("fullName")}
                                    <br/>
                                    {localStorage.getItem("userRole")}
                       </a>
                       <div class="sb-sidenav-menu-heading">Menu</div>
                     
                       <a class="nav-link collapsed" href="#" data-bs-toggle="collapse" data-bs-target="#collapseLayouts" aria-expanded="false" aria-controls="collapseLayouts">
                           <div class="sb-nav-link-icon"><i class="fas fa-columns"></i></div>
                           Stage 1
                           <div class="sb-sidenav-collapse-arrow"><i class="fas fa-angle-down"></i></div>
                       </a>
                       <div class="collapse" id="collapseLayouts" aria-labelledby="headingOne" data-bs-parent="#sidenavAccordion">
                           <nav class="sb-sidenav-menu-nested nav">
                               <a class="nav-link" href="/admin/auditlist">Client List</a>
                               <a class="nav-link" href="/admin/rfq">RFQ</a>
                               <a class="nav-link" href="/admin/contractreview">Contract Review</a>
                               <a class="nav-link" href="/admin/auditagreements">Audit Agreement</a>
                               <a class="nav-link" href="/admin/auditteamproposal">Audit Team Proposal</a>
                               <a class="nav-link" href="/admin/auditplan">Audit Plan</a>
                               <a class="nav-link" href="/admin/auditobservation">Audit Observation</a>
                               <a class="nav-link" href="/admin/stage1auditreport">270001 Observation</a>
                               <a class="nav-link" href="/admin/reviewofauditprocesses">Review of Audit</a>
                               <a class="nav-link" href="/admin/auditeedetails">Auditee Details</a>
                               <a class="nav-link" href="/admin/attendancesheet">Audit Attendance Sheet</a>
                               {/* <a class="nav-link" href="/admin/imsstage1auditreport">Ims Stage 1 Audit Report</a> */}
                               <a class="nav-link" href="/admin/emsstage1auditreport">Ems Stage 1 Audit Report</a>
                               <a class="nav-link" href="/admin/ohsmsstage1auditreport">Ohsms Stage 1 Audit Report</a>
                               {/* <a class="nav-link" href="/admin/Imsnew90011400145001stage1auditreport">Ims All Stage 1 Audit Report</a> */}

                           </nav>
                       </div>

                       <a class="nav-link collapsed" href="#" data-bs-toggle="collapse" data-bs-target="#collapseStage2" aria-expanded="false" aria-controls="collapseStage2">
                           <div class="sb-nav-link-icon"><i class="fas fa-columns"></i></div>
                           Stage 2
                           <div class="sb-sidenav-collapse-arrow"><i class="fas fa-angle-down"></i></div>
                       </a>

                       <div class="collapse" id="collapseStage2" aria-labelledby="headingOne" data-bs-parent="#sidenavAccordion">
                           <nav class="sb-sidenav-menu-nested nav">
                           <a class="nav-link" href="/admin/stage2auditlist">Client List</a> 
                               <a class="nav-link" href="/admin/stage2auditplan">Audit Plan</a> 
                               <a class="nav-link" href="/admin/auditreport">Audit Reports</a> 
                               <a class="nav-link" href="/admin/stage2auditreportiso27001">270001 Observation</a> 
                               {/* <a class="nav-link" href="/admin/imsstage2auditreport">Ims Stage 2 Audit Report</a> */}
                               <a class="nav-link" href="/admin/certificatedeccommittee">CDC deliberation & decision</a>
                               <a class="nav-link" href="/admin/approvalofteamleader"> Team Lead Approval</a>
                               <a class="nav-link" href="/admin/stage2reviewofaudit">Review of Audit</a>
                               <a class="nav-link" href="/admin/correctiveactionreport">Corrective Action Report</a> 
                               <a class="nav-link" href="/admin/stage2auditobservationsheet">Audit Observation</a>
                               <a class="nav-link" href="/admin/emsstage2auditreport">Ems Stage 2 Audit Report</a>
                               <a class="nav-link" href="/admin/ohsmsstage2auditreport">Ohsms Stage 2 Audit Report</a>
                               {/* <a class="nav-link" href="/admin/Imsnew90011400145001stage2auditreport">Ims All Stage 2 Audit Report</a> */}


                           </nav>
                       </div>
                        <a class="nav-link collapsed" href="#" data-bs-toggle="collapse" data-bs-target="#collapseStage5" aria-expanded="false" aria-controls="collapseStage2">
                           <div class="sb-nav-link-icon"><i class="fas fa-columns"></i></div>
                           Surveillance 
                           <div class="sb-sidenav-collapse-arrow"><i class="fas fa-angle-down"></i></div>
                       </a>
                       <div class="collapse" id="collapseStage5" aria-labelledby="headingOne" data-bs-parent="#sidenavAccordion">
                           <nav class="sb-sidenav-menu-nested nav">
                           <a class="nav-link" href="/admin/surveillancelist">Client List</a>
                            <a class="nav-link" href="/admin/surveillanceauditassign">Audit Assign</a> 
                            <a class="nav-link" href="/admin/auditplanmatrix">Audit Plan</a> 
                            <a class="nav-link" href="/admin/auditexecution">Audit Execution</a> 
                            <a class="nav-link" href="/admin/surveillanceobservation">Audit Observation</a>
                            <a class="nav-link" href="/admin/bothsurveillancereports">Reports</a>
                           


                           </nav>
                       </div> 
                        <a class="nav-link collapsed" href="#" data-bs-toggle="collapse" data-bs-target="#collapseStage6" aria-expanded="false" aria-controls="collapseStage2">
                           <div class="sb-nav-link-icon"><i class="fas fa-columns"></i></div>
                          Email-Sent
                           <div class="sb-sidenav-collapse-arrow"><i class="fas fa-angle-down"></i></div>
                       </a>
                       <div class="collapse" id="collapseStage6" aria-labelledby="headingOne" data-bs-parent="#sidenavAccordion">
                           <nav class="sb-sidenav-menu-nested nav">
                           <a class="nav-link" href="/admin/email">Email Creation</a>
                           <a class="nav-link" href="/admin/email/dashboard">Email Dashboard</a> 
                           
                           </nav>
                       </div> 
                       <a class="nav-link collapsed" href="#" data-bs-toggle="collapse" data-bs-target="#collapsemasters" aria-expanded="false" aria-controls="collapsemasters">
                           <div class="sb-nav-link-icon"><i class="fas fa-columns"></i></div>
                          Masters
                           <div class="sb-sidenav-collapse-arrow"><i class="fas fa-angle-down"></i></div>
                       </a>
                       <div class="collapse" id="collapsemasters" aria-labelledby="headingOne" data-bs-parent="#sidenavAccordion">
                           <nav class="sb-sidenav-menu-nested nav">
                            <a class="nav-link" href="/admin/typeoforganization">Type of Organization</a> 
                            <a class="nav-link" href="/admin/typeofcertification">Type of Certification</a> 
                            <a class="nav-link" href="/admin/mandays">Mandays</a>  
                            <a class="nav-link" href="/admin/nacecode">Nacecode</a> 
                            <a class="nav-link" href="/admin/processmaster">Process Master</a>
                            <a class="nav-link" href="/admin/listoftechnicalexpert">List of Technical Expert</a>
                            <a class="nav-link" href="/admin/listofclauses">List of Clauses</a>
                            {/* <a class="nav-link" href="/admin/listofimsclauses">List of IMS Clauses</a> */}
                            <a class="nav-link" href="/admin/access">Access Management</a>
                            <a class="nav-link" href="/admin/listofleadauditorform">List of Competancy</a>
                            <a class="nav-link" href="/admin/listofdeleteorg">Delete Org</a>
                            <a class="nav-link" href="/admin/othercertificationstatus">Data Entry : Other Certified Org</a>
                            <a class="nav-link" href="/admin/listofcertificationstatus">Certified Org. List</a>
                            <a class="nav-link" href="/admin/departmentmaster">Department Master</a>
                            {/* <a class="nav-link" href="/statuscompleteform">View Status - Certified Org</a> */}
                            <a class="nav-link" href="/otherstatuscompleteform">View Status - Other Certified Org</a>

                            
                           </nav>
                       </div>
                       <a class="nav-link collapsed" href="#" data-bs-toggle="collapse" data-bs-target="#collapsecompetancy" aria-expanded="false" aria-controls="collapsemasters">
                           <div class="sb-nav-link-icon"><i class="fas fa-columns"></i></div>
                           Competancy
                           <div class="sb-sidenav-collapse-arrow"><i class="fas fa-angle-down"></i></div>
                       </a>
                       <div class="collapse" id="collapsecompetancy" aria-labelledby="headingOne" data-bs-parent="#sidenavAccordion">
                           <nav class="sb-sidenav-menu-nested nav">
                            <a class="nav-link" href="/admin/listofleadauditorform">List of Competancy</a>
                            <a class="nav-link" href="/admin/competancymatrixreports">Competancy Matrix Report</a>
                            <a class="nav-link" href="/admin/competancyreports">Reports</a>
                           </nav>
                       </div>
                       <a class="nav-link collapsed" href="#" data-bs-toggle="collapse" data-bs-target="#collapseStage4" aria-expanded="false" aria-controls="collapseStage2">
                           <div class="sb-nav-link-icon"><i class="fas fa-columns"></i></div>
                           User Management
                           <div class="sb-sidenav-collapse-arrow"><i class="fas fa-angle-down"></i></div>
                       </a>
                       <div class="collapse" id="collapseStage4" aria-labelledby="headingOne" data-bs-parent="#sidenavAccordion">
                           <nav class="sb-sidenav-menu-nested nav">
                           <a class="nav-link" href="/admin/register">Register User</a> 
                           <a class="nav-link" href="/admin/listuser">List Of User</a> 
                            <a class="nav-link" href='/admin/user/dashboard'>User Dashboard</a>
                              
                           </nav>
                       </div>

                       
                   </div>
               </div>
           </nav>
       </div>
   </div>
    )
}

export default AdminMenu
